export default "__VITE_ASSET__CrwqoLhc__"